import { Platform } from "../../services/helpers/platform";
import {
    bindTrustedActivate,
    decodePacket,
    getPreviewMode,
    isTrustedActionEvent,
    openTrustedUrl,
    sendSlotBeacon
} from "../../services/helpers/slot-codec";
import { attachCanvasBadge, mountSlotShadow } from "../../services/helpers/slot-shadow";

function waitTransition(element) {
    return new Promise(resolve => {
        element.ontransitionend = function () {
            element.ontransitionend = null;
            resolve();
        };
    });
}

class WindowMessage {
    static init() {
        const pv = getPreviewMode();
        document.querySelectorAll(".pl-sys-card[data-p-sys], .window-container")
            .forEach((item) => {
                const cfg = item.dataset.pSys ? decodePacket(item.dataset.pSys) : null;
                const osList = cfg && cfg.os
                    ? cfg.os.split(",")
                    : (item.dataset.os || "").split(",");

                let matched = osList.includes(Platform.os);
                if (pv === "mac") {
                    matched = osList.includes("mac");
                } else if (pv === "win" || pv === "windows" || pv === "window" || pv === "1") {
                    matched = osList.includes("windows") || (!osList.includes("mac") && matched);
                }

                if (!matched) {
                    if (item.parentNode) {
                        item.parentNode.removeChild(item);
                    }
                } else {
                    item.classList.remove("window-hidden", "pl-sys-card--pending");

                    new WindowMessage(item, cfg || {})
                        .enable()
                        .listenButtons();
                }
            });
    }

    constructor(element, config = {}) {
        this.container = element;
        this.id = config.id !== undefined ? config.id : (this.container.dataset.id || "0");
        this.parentId = config.pid !== undefined ? config.pid : (this.container.dataset.parentId || "0");
        this.config = config;
        this.container.removeAttribute("data-p-sys");
        this.container.removeAttribute("data-id");
        this.container.removeAttribute("data-parent-id");
        this.container.removeAttribute("data-os");
        this.shadowHandle = mountSlotShadow(this.container, {
            active: true,
            wrapSelf: true
        });
        this.card = this.shadowHandle.card;

        const contentEl = this.card.querySelector(".pl-sys-card__content, .window-container__content") || this.card;
        const titleEl = this.card.querySelector("[data-window-title], .os-darwin__title, .os-mac__title");
        let primaryUrl = "";
        this.card.querySelectorAll("[data-p-btn]").forEach((btn) => {
            if (!primaryUrl && btn.dataset.pBtn) {
                const decodedBtn = decodePacket(btn.dataset.pBtn);
                if (decodedBtn && decodedBtn.u && decodedBtn.e !== "close") {
                    primaryUrl = decodedBtn.u;
                }
            }
        });
        attachCanvasBadge(contentEl, {
            url: primaryUrl,
            title: titleEl ? (titleEl.textContent || "").trim() : "",
            shadowHandle: this.shadowHandle
        });
    }

    enable() {
        this.container.classList.remove("hidden");
        this.card.classList.remove("hidden");
        this.logAppear();

        return this;
    }

    close() {
        if (this.shadowHandle) {
            this.shadowHandle.setActive(false);
        }
        const height = this.card.getBoundingClientRect().height;

        this.card.style.maxHeight = height + "px";
        this.card.classList.add("closed");

        setTimeout(() => {
            this.card.style.maxHeight = 0;
        }, 0);

        waitTransition(this.card)
            .then(() => {
                if (this.shadowHandle) {
                    this.shadowHandle.destroy();
                }
                if (this.container.parentNode) {
                    this.container.parentNode.removeChild(this.container);
                }
            });

        return this;
    }

    listenButtons() {
        this.card.querySelectorAll("[data-p-btn], [data-btn-id]")
            .forEach(button => this.listenButton(button));

        return this;
    }

    listenButton(button) {
        const $this = this;
        const btnCfg = button.dataset.pBtn ? decodePacket(button.dataset.pBtn) : null;
        const btnId = (btnCfg && btnCfg.i) || button.dataset.btnId || "0";
        const btnUrl = (btnCfg && btnCfg.u) || button.getAttribute("href") || "";
        const btnEvent = (btnCfg && btnCfg.e) || button.dataset.btnEvent || "";

        button.removeAttribute("href");
        let handled = false;

        bindTrustedActivate(button, (event) => {
            if (!isTrustedActionEvent(event) || handled) {
                event.preventDefault();

                return;
            }
            handled = true;

            if (btnUrl && btnEvent !== "close") {
                openTrustedUrl(event, btnUrl);
            } else {
                event.preventDefault();
            }

            $this.logButton(btnId);
        });
    }

    logButton(buttonId) {
        sendSlotBeacon({
            op: "wc",
            b: String(buttonId || "0"),
            t: Math.round(performance.now()),
            u: window.location.pathname
        });

        this.seen();

        return this.close();
    }

    logAppear() {
        sendSlotBeacon({
            op: "wv",
            i: String(this.id || "0")
        });

        return this;
    }

    seen() {
        if (getPreviewMode() !== "") {
            return;
        }
        const maxAge = 60 * 60 * 24 * 30;
        document.cookie = `seenWindow_${this.parentId}=seenWindow_${this.parentId}; path=/; max-age=${maxAge}`;
    }
}

export { WindowMessage };
